import React, { useEffect, useState } from 'react';

const PostBadges = ({ postType = "blog" }) => {
    const [colorLabel, setColorLabel] = useState("sky-blue");

    useEffect(() => {
        switch (postType) {
            case "youtube":
                setColorLabel("rose-red");
                break;
            case "ipfs": 
                setColorLabel("cloud-pink");
                break;
            case "clip": 
                setColorLabel("savage-phoenix");
                break;
            default:
                setColorLabel("sky-blue");
                break;
        }
    }, [postType]);

    return (
        <div className="post-menu post-badges" style={{ display: "flex", alignItems: "center", zIndex: 997 }}>
            {postType === "youtube" && (
                <span className={`post-menu-item post-menu-btn`}>
                    <img src="/assets/img/youtube-icon.png" alt="YouTube" style={{ height: "18px", width: "auto" }} />
                </span>
            )}
            {postType === "clip" && (
                <>
                    <span className={`post-menu-item post-menu-btn mr-1`}>
                        <img src="/assets/img/ipfs-icon.svg" alt="IPFS" style={{ height: "18px", width: "auto" }} />
                    </span>
                    <span className={`post-menu-item post-menu-btn `}>
                        <img src={`/assets/img/v-white.png`} alt="Vertical" style={{ height: "14px", width: "auto" }} />
                    </span>
                </>
            )}
            {postType === "ipfs" && (
                <>
                    <span className={`post-menu-item post-menu-btn mr-1`}>
                        <img src="/assets/img/ipfs-icon.svg" alt="IPFS" style={{ height: "18px", width: "auto" }} />
                    </span>
                    <span className={`post-menu-item post-menu-btn `}>
                        <img src={`/assets/img/h-white.png`} alt="Horizontal" style={{ height: "14px", width: "16px" }} />
                    </span>
                </>
            )}
            {postType === "blog" && (
                <span className={`post-menu-item post-menu-btn `}>
                    <i className="fas fa-align-left" style={{ fontSize: "14px", color: "white" }} />
                </span> 
            )}
            {(postType !== "youtube" && postType !== "clip" && postType !== "ipfs" && postType !== "blog") && (
                <span className={`post-menu-item post-menu-btn  ${colorLabel}`} style={{ padding: "0 10px" }}>
                    {postType}
                </span> 
            )}
        </div>
    );
};

export default PostBadges;
